export const APP_PREFIX = 'PENZO';
